import { handleRest } from '../../h2Api'
import {
  PROFILE_CONTACT_ADDED,
  PROFILE_CONTACT_UPDATED,
  PROFILE_CONTACTS_LOADED
} from '../../actions/admin/adminLocalOpportunityActions'

const initialRequestState = handleRest()
const reducers = (state = initialRequestState, action) => {
  switch (action.type) {
    case PROFILE_CONTACTS_LOADED:
      return {
        ...state,
        ...handleRest(action)
      }
    case PROFILE_CONTACT_ADDED:
      console.log(state)

      return {
        ...state,
        result: [action.result, ...state.result]
      }
    case PROFILE_CONTACT_UPDATED:
      console.log(state)

      return {
        ...state,
        result: [action.result, ...state.result.filter(r => r.id !== action.result.id)]
      }
    default:
      return state
  }
}

export default reducers
